import React from 'react';

import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => (
  <div className="app__aboutus app__bg flex__center section__padding" id="about">
    <div className="app__aboutus-overlay flex__center">
    </div>

    <div className="app__aboutus-content flex__center">
      <div className="app__aboutus-content_about">
        <h1 className="headtext__cormorant">About Us</h1>
        <img src={images.line} alt="about_line" className="line__img" />
        <p className="p__opensans">Selamat datang di ClipperCraft, tempat di mana kami mengubah potongan rambut menjadi pengalaman yang memenuhi dan melebihi harapan Anda.</p>
        <button type="button" className="custom__button">Know More</button>
      </div>

      <div className="app__aboutus-content_pole flex__center">
        <img src={images.pole} alt="pole" />
      </div>

      <div className="app__aboutus-content_history">
        <h1 className="headtext__cormorant">Our History</h1>
        <img src={images.line} alt="about_line" className="line__img" />
        <p className="p__opensans">ClipperCraft telah menjadi tujuan utama bagi mereka yang mencari potongan rambut berkualitas tinggi sejak didirikan. Kami berjanji untuk terus berinovasi demi kepuasan Anda.</p>
        <button type="button" className="custom__button">Know More</button>
      </div>
      
    </div>
  </div>
);

export default AboutUs;
